exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#scadaSettingsModal .v--modal-box.v--modal{min-width:380px!important;min-height:400px!important}#scadaSettingsModal .modal__content{overflow-y:hidden!important}#scadaSettingsModal .v-input__slot,#scadaSettingsModal label{font-size:12px}#scadaSettingsModal .menuable__content__active{max-height:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c579b7a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/scada/modals/ScadaSettings.vue
// module id = 2130
// module chunks = 0